import React, { Component } from 'react';
import PropTypes from 'prop-types';
import QRCode from 'qrcode.react';
import getLocaleMessages from '../../utils/localesMessages';

const {
	qr: {
		share,
		download
	},
	tabQRCode
} = getLocaleMessages('buttons/buttonCompleteDetails')

class ButtonQRCode extends Component {
	static propTypes = {
		button: PropTypes.object,
		isMobile: PropTypes.bool
	}

	downloadQRCode = (el) => {
		var canvas = document.getElementsByTagName('canvas')[0];
		var downloadedFile = `${tabQRCode}.png`;

		if (canvas.msToBlob) {
			var blob = canvas.msToBlob();
			window.navigator.msSaveBlob(blob, downloadedFile);
		} else {
			var code = canvas.toDataURL('image/png');
			el.target.href = code;
			el.target.download = downloadedFile;
		}
	}

	render() {
		const button_url = this.props.button.email_code + '&source=qr';

		return (
			<div className="button-detail-body QR-code">
				<p>{share}</p>

				<div className="QR-code-container">
					<QRCode
						value={button_url}
						style={{ width: '100%', height: '100%' }}
						renderAs="canvas"
					/>
					<div className="download">
						<img src="https://www.paypalobjects.com/images/Cause/ic_download.svg" />
						<a onClick={this.downloadQRCode}>{download}</a>
					</div>
				</div>
			</div>
		)
	}
}
export default ButtonQRCode;



// WEBPACK FOOTER //
// ./buttons/components/buttonDetails/ButtonQRCode.js